import { createComponent } from "@helpers/admin";
import BasicSectionComponent from "@template/blocks/BasicSection/component";

export const BasicSection = createComponent({
  label: "Basic Section",
  component: BasicSectionComponent,
  resolveFields: async (data) => {
    const renderedContent =
      data?.props?.contentType === "quotes"
        ? {
            quotes: {
              label: "Quotes",
              type: "array" as const,
              arrayFields: {
                mainQuote: {
                  label: "Main Quote",
                  type: "textarea" as const,
                },
                quotedPerson: {
                  label: "Person Quoted",
                  type: "text" as const,
                },
                company: {
                  label: "Company",
                  type: "text" as const,
                },
                link: {
                  label: "Link",
                  type: "text" as const,
                },
              },
            },
          }
        : data?.props?.contentType === "video"
          ? {
              videoUrl: {
                label: "Video",
                type: "text" as const,
              },
            }
          : {
              image: {
                label: "Image",
                type: "image" as const,
              },
            };

    return {
      title: {
        label: "Title",
        type: "textarea",
      },
      subtitle: {
        label: "Subtitle",
        type: "textarea",
      },
      description: {
        label: "Description",
        type: "markdown",
      },
      accordionHeader: {
        label: "Links Header",
        type: "textarea",
      },
      anchorId: {
        label: "Anchor ID",
        type: "textarea",
      },
      myCustomButton: {
        label: "Test",
        type: "button",
      },
      header: {
        label: "Header",
        type: "object",
        objectFields: {
          title: {
            label: "Title",
            type: "textarea",
          },
          subtitle: {
            label: "Subtitle",
            type: "textarea",
          },
        },
      },
      contentType: {
        label: "Content Type",
        type: "select",
        options: [
          { label: "Image", value: "image" },
          { label: "Quotes", value: "quotes" },
          { label: "Video", value: "video" },
        ],
      },
      ...renderedContent,
      button: {
        label: "Button",
        type: "button",
      },
      bullets: {
        label: "Bullet Points",
        type: "array",
        arrayFields: {
          text: {
            type: "textarea",
            label: "Text",
          },
        },
      },
      accordionData: {
        label: "Accordion",
        type: "array",
        arrayFields: {
          title: {
            label: "Title",
            type: "textarea",
          },
          content: {
            label: "Content",
            type: "textarea",
          },
        },
      },
      linkContent: {
        label: "Links",
        type: "array",
        arrayFields: {
          label: {
            label: "Text",
            type: "text",
          },
          link: {
            label: "Link",
            type: "text",
          },
          target: {
            label: "Open In New Tab",
            type: "select",
            options: [
              { label: "Yes", value: "_blank" },
              { label: "No", value: "_self" },
            ],
          },
          title: {
            label: "Title",
            type: "textarea",
          },
        },
      },
      bulletsWithIcon: {
        label: "Bullet Point Checkmarks",
        type: "boolean",
        default: true,
      },
      flip: {
        label: "Flip Content and Image",
        type: "boolean",
      },
      inverted: {
        label: "Grey Background",
        type: "boolean",
      },
    };
  },
});
